import { render, staticRenderFns } from "./login-header.vue?vue&type=template&id=6216508c&scoped=true"
import script from "./login-header.vue?vue&type=script&lang=js"
export * from "./login-header.vue?vue&type=script&lang=js"
import style0 from "./login-header.vue?vue&type=style&index=0&id=6216508c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6216508c",
  null
  
)

export default component.exports